
































import Vue, { PropType } from 'vue';
import Datepicker from 'vuejs-datepicker';
import { calender } from 'mostra';
import { FirestoreDate } from '@/modules/firestore';
// import moment from 'moment-timezone';

interface DataType {
  dateValue: Date | string | null;
  requiredError: boolean;
}

export default Vue.extend({
  name: 'GDatePicker',
  components: {
    Datepicker,
  },
  props: {
    label: { type: String as PropType<string>, default: null },
    isRequired: { type: Boolean as PropType<boolean>, default: false },
    value: { type: [Date, Object, String] as PropType<FirestoreDate>, default: null },
    name: { type: String as PropType<string>, required: true },
    disabled: { type: Boolean as PropType<boolean>, default: false },
    isRight: { type: Boolean as PropType<boolean>, default: false },
    duplicateError: { type: Boolean as PropType<boolean>, default: false },
    coupleValueError: { type: Boolean as PropType<boolean>, default: false },
    formatError: { type: Boolean as PropType<boolean>, default: false },
  },
  data(): DataType {
    return {
      dateValue: calender.formatDate(this.value),
      requiredError: false,
    };
  },
  watch: {
    dateValue(date: string) {
      this.dateSelected(date);
      this.$emit('selected', date);
    },
  },
  computed: {
    innerValue: {
      get(): Date {
        return calender.toDate(this.value);
      },
      set(date: Date): void {
        // this.dateValue = moment(date).format('YYYY/MM/DD');
        this.dateValue = calender.formatDate(date);
      },
    },
  },
  methods: {
    dateSelected(date: string) {
      this.requiredError = !date;
    },
  },
});
